










































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import SaveDialog from "./saveDialog.vue";
@Component({
  components: {
    SaveDialog
  }
})
export default class ResultFilterCmp extends Vue {
  @Prop()
  private message: any;
  @Prop()
  private result: any;
  @Prop()
  private saveDisabled: any;
  @Prop()
  private ifGotResult: any;
  private projects: any[] = [];
  private tables: any[] = [];
  private ifShowSaveDialog: boolean = false;
  private messageChange() {
    this.$emit("update:message", this.message);
  }
  private resultChange() {
    this.$emit("update:result", this.result);
  }
  /**
   * @description 获取项目列表
   */
  private fetchProjects() {
    axios.get("api/wajue/projects").then(({ data }) => {
      resHandle(this, data).then(() => {
        this.projects = data.data;
      });
    });
  }
  /**
   * @description 分析的项目改变
   */
  private projectChange() {
    this.$emit("projectChange");
    this.fetchTables();
  }
  /**
   * @description 获取数据表格
   */
  private fetchTables() {
    const params: any = {
      params: {
        project_id: this.message.project_id
      }
    };
    axios.get("api/wajue/tables", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.tables = data.data;
        this.tables.unshift({ table_id: "", 表格名称: "全部数据表格" });
      });
    });
  }
  /**
   * @description 分析的表格改变
   */
  private tableChange() {
    this.$emit("tableChange");
  }
  /**
   * @description 开始分析
   */
  private startAnalysis() {
    this.$emit("start");
  }
  /**
   * @description 打开保存弹窗
   */
  private openSaveDialog() {
    this.ifShowSaveDialog = true;
  }
  /**
   * @description 保存报告
   */
  private save() {
    console.log(this.result);
    const params: any = {
      project_id: this.message.project_id,
      table_id: this.message.table_id,
      报告名称: this.message["报告名称"],
      分类: this.message["分类"],
      data: this.result
    };
    params.data["分析类型"] = this.message["分析类型"];
    params.data["访视索引"] = this.message["访视索引"];
    axios.post("api/wajue/report", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("保存成功");
        this.ifShowSaveDialog = false;
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchProjects();
    this.fetchTables();
  }
}
